import React, { useState, useEffect } from "react";
import "../../css/packageDeal.css";
import { getActivePromotions } from "../../api/promotions";
import packageDeal1 from '../../assets/images/package-deal-1.png';
import packageDeal2 from '../../assets/images/package-deal-2.png';
import packageDeal3 from '../../assets/images/package-deal-3.png';

// Fallback static data
const fallbackDeals = [
  {
    title: "You can Bundle & Save up to $974 with package deals!",
    linkText: "Explore packages",
    image: packageDeal1,
  },
  {
    title: "Get our best deals on flights with Price Drop Protection",
    linkText: "Learn more",
    image: packageDeal2,
  },
  {
    title: "Members save 10% or more on over 100,000 hotels worldwide",
    linkText: "Treat yourself",
    image: packageDeal3,
  },
];

const PackageDeal = () => {
  const [deals, setDeals] = useState(fallbackDeals);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromotions = async () => {
      try {
        setLoading(true);
        const response = await getActivePromotions();
        
        if (response.success && response.data && response.data.length > 0) {
          // Transform promotions data to deals format
          const promotionDeals = response.data.map(promotion => ({
            id: promotion.id,
            title: promotion.title,
            linkText: promotion.message || "Learn more",
            image: (promotion.images && promotion.images.length > 0) ? promotion.images[0] : fallbackDeals[0].image,
            url: promotion.url
          }));
          
          setDeals(promotionDeals);
        } else {
          // No promotions available
          setDeals([]);
        }
      } catch (error) {
        console.error('Failed to fetch promotions:', error);
        // No promotions on error
        setDeals([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPromotions();
  }, []);

  if (loading) {
    return (
      <div className="package-deal">
        <div className="container">
          <div className="package-deal-loading">
            <p>Loading package deals...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="package-deal">
        <div className="container">
            {deals.length === 0 ? (
              <div className="package-deal-no-data">
                <p>No promotions at this moment.</p>
              </div>
            ) : (
              <div className="package-deal-container">
                {deals.map((deal, index) => (
                    <div className="package-deal-card" key={deal.id || index}>
                    <div className="package-deal-info">
                        <h3>{deal.title}</h3>
                        {deal.url ? (
                          <a href={deal.url} target="_blank" rel="noopener noreferrer">
                            {deal.linkText} <i className="fas fa-arrow-right"></i>
                          </a>
                        ) : (
                          <a href="#">
                            {deal.linkText} <i className="fas fa-arrow-right"></i>
                          </a>
                        )}
                    </div>
                    <div className="package-deal-image">
                        <img src={deal.image} alt={deal.title} />
                    </div>
                    </div>
                ))}
              </div>
            )}
        </div>
    </div>
  );
};

export default PackageDeal;